// import axios from "axios";

// const INTELLICONVO_API = axios.create({
//   baseURL: process.env.REACT_APP_INTELLICONVO_LOGIN_URL || "http://216.48.179.107:8020/app",
// });

// const API = axios.create({
//   baseURL: process.env.REACT_APP_SERVER_API_URL,
// });

// API.interceptors.request.use(
//   (config) => {
//     let token = localStorage.getItem("token");
//     let userData = null;

//     const storedData = localStorage.getItem("userLoggedIn");
//     if (storedData) {
//       try {
//         userData = JSON.parse(storedData);
//         if (!token) {
//           token = userData?.token;
//         }
//       } catch (error) {
//         console.error("Error parsing userLoggedIn:", error);
//       }
//     }

//     if (token) {
//       config.headers["Authorization"] = `Bearer ${token}`;
//     }

//     // Add multitenancy and session-binding headers if available
//     if (userData) {
//       if (userData.session_jti) {
//         config.headers["session_jti"] = userData.session_jti;
//       }
//       if (userData.active_u1_session_jti) {
//         config.headers["active_u1_session_jti"] = userData.active_u1_session_jti;
//       }
//       if (userData.organisation_id) {
//         config.headers["organisation_id"] = userData.organisation_id;
//       }
//       if (userData.customer_id) {
//         config.headers["customer_id"] = userData.customer_id;
//       }
//       if (userData.user_id) {
//         config.headers["user_id"] = userData.user_id;
//       }
//     }

//     console.log(`Axios Request [${config.method.toUpperCase()}] ${config.url}:`, {
//       hasToken: !!token,
//       authHeader: config.headers["Authorization"],
//       organisation_id: config.headers["organisation_id"],
//       customer_id: config.headers["customer_id"],
//       user_id: config.headers["user_id"],
//       session_jti: config.headers["session_jti"],
//       active_u1_session_jti: config.headers["active_u1_session_jti"],
//     });
//     return config;
//   },
//   (error) => {
//     return Promise.reject(error);
//   }
// );

// // Add a response interceptor
// API.interceptors.response.use(
//   (response) => {
//     // Automatically unwrap the 'data' field if the response follows the new standard
//     if (
//       response.data &&
//       (response.data.status === "success" || response.data.status === "partial_success") &&
//       response.data.data !== undefined
//     ) {
//       response.data = response.data.data;
//     }
//     return response;
//   },
//   (error) => {
//     if (error.response && error.response.status === 401) {
//       // Don't redirect if we are already on the login page or trying to login
//       const url = error.config.url || "";
//       const isLoginRequest = url.includes("/login");
//       if (!isLoginRequest) {
//         localStorage.clear();
//         window.location.replace("/login");
//       }
//     }
//     return Promise.reject(error);
//   }
// );

// export { INTELLICONVO_API, API };
// export default API;

import axios from "axios";

// ✅ FIX 1 (Mixed Content) — Read runtime ConfigMap (window._env_) first,
//    then build-time process.env, then safe relative fallback.
//    Previously fell back to hardcoded http:// IP → blocked on HTTPS pages.
const getEnv = (key, fallback) =>
  window?._env_?.[key] || process.env[key] || fallback;

const INTELLICONVO_API = axios.create({
  baseURL: getEnv("REACT_APP_INTELLICONVO_LOGIN_URL", "/app"),
});

// ✅ FIX 2 (401 after login) — INTELLICONVO_API was missing a response interceptor.
//    Login backend returns: { status: "success", data: { token, user_id, ... } }
//    Without unwrapping, res.data.token = undefined → Authorization header never set → 401.
INTELLICONVO_API.interceptors.response.use(
  (response) => {
    if (
      response.data &&
      (response.data.status === "success" || response.data.status === "partial_success") &&
      response.data.data !== undefined
    ) {
      response.data = response.data.data;
    }
    return response;
  },
  (error) => {
    return Promise.reject(error);
  }
);

const API = axios.create({
  baseURL: getEnv("REACT_APP_SERVER_API_URL", "/app"),
});

API.interceptors.request.use(
  (config) => {
    let token = localStorage.getItem("token");
    let userData = null;

    const storedData = localStorage.getItem("userLoggedIn");
    if (storedData) {
      try {
        userData = JSON.parse(storedData);
        if (!token) {
          token = userData?.token;
        }
      } catch (error) {
        console.error("Error parsing userLoggedIn:", error);
      }
    }

    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }

    // Add multitenancy and session-binding headers if available
    if (userData) {
      if (userData.session_jti) {
        config.headers["session_jti"] = userData.session_jti;
      }
      if (userData.active_u1_session_jti) {
        config.headers["active_u1_session_jti"] = userData.active_u1_session_jti;
      }
      if (userData.organisation_id) {
        config.headers["organisation_id"] = userData.organisation_id;
      }
      if (userData.customer_id) {
        config.headers["customer_id"] = userData.customer_id;
      }
      if (userData.user_id) {
        config.headers["user_id"] = userData.user_id;
      }
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add a response interceptor
API.interceptors.response.use(
  (response) => {
    // Automatically unwrap the 'data' field if the response follows the new standard
    if (
      response.data &&
      (response.data.status === "success" || response.data.status === "partial_success") &&
      response.data.data !== undefined
    ) {
      response.data = response.data.data;
    }
    return response;
  },
  (error) => {
    if (error.response && error.response.status === 401) {
      // Don't redirect if we are already on the login page or trying to login
      const url = error.config.url || "";
      const isLoginRequest = url.includes("/login");
      if (!isLoginRequest) {
        localStorage.clear();
        window.location.replace("/login");
      }
    }
    return Promise.reject(error);
  }
);

export { INTELLICONVO_API, API };
export default API;